module.exports = __webpack_public_path__ + "static/r2-98c68e883fbdc391c1ba2d876ea80af7.svg";